import React from 'react';

import TestimonialSection from './TestimonialSection';
import ServiceSlider from "./ServiceSlider2";
import FaqAccordion from "./FaqAccordion";
import ContactSection from "./ContactSection";
import Footer from "./Footer"; 

import CScontent2 from "./CScontent2";
import CScontent22 from "./CScontent2_2";
import Number from "./numbers";

const CaseStudiesTwo = () => {
  return (
    <>
        <CScontent2 />
      <TestimonialSection />
      <Number></Number>
       <div style={{ marginTop: "250px" }}>
              <ServiceSlider />
              </div>
       <CScontent22 />
       <FaqAccordion />
      <ContactSection />
      <Footer />
    </>
  );
};

export default CaseStudiesTwo;